<template>
  <div class="pt-0" style="padding-left: 2%; padding-right: 2%; background-color: #F8F9FA; min-height: 100vh;">
    <!-- <h2 class="txt-head">
      เพิ่มบริษัทใหม่
    </h2> -->
    <OverlayLoading :loading="loading" />
    <v-row class="mb-2">
      <v-col cols="8">
        <img width="17" height="17" src="@/assets/icons/back-icon.png" class="mt-5 ml-0" style="cursor: pointer;" @click="goBack()">
        <span class="header-title ml-0" style="font-size: 18px;">
          บริษัท: <span class="header-title" style="font-weight: 400; font-size: 16px;">{{companyName}}</span>
        </span>
        <span class="header-title ml-0" style="font-size: 18px;">
          สายบังคับบัญชา: <span class="header-title" style="font-weight: 400; font-size: 16px;">{{orgChartDetail}} </span>
        </span>
      </v-col>
      <v-col cols="4" class="pt-0 pb-0 d-flex align-center justify-end mt-0">
        <v-btn class="ma-0 mx-2" outlined color="#3776E9" dark @click="goHistory()">
          <v-icon
            color="#3776E9 darken-2"
            class="pr-0"
            small
          >
            mdi-history
          </v-icon>
          <span class="mx-1">History</span>
        </v-btn>
        <v-btn class="ma-1 mr-2" color="#3776E9" dark @click="goCreateTransfer">
          <v-icon
            color="#3776E9 darken-2"
            class="pl-0"
            small
          >
            mdi-account-multiple
          </v-icon>
          <span class="mx-1">โอนสิทธิ์</span>
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-card height="auto" min-height="82vh" class="pt-7 pb-7" >
        <v-row>
          <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0 pl-12">
            <span class="head-search-text">ค้นหาชื่อสิทธิ์</span>
            <v-autocomplete
              v-model="selectRoleList"
              :items="roleList"
              item-text="name"
              item-value="_id"
              outlined
              dense
              clearable
              class="mt-2"
              placeholder="ค้นหาได้จากชื่อสิทธิ์"
              no-data-text="ไม่พบข้อมูล"
              @change="searchFilterData()"
            >
            <template v-slot:append>
              <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
            </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="1" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-width="200"
              :nudge-top='-10'
              max-width="328"
              left
              offset-y
              origin='left'
              tile
              z-index="0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="head-search-button"
                  style="width: 96px; height: 38px;"
                  text
                  color="primary"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>
                    mdi-filter-variant
                  </v-icon>
                  ตัวกรอง
                </v-btn>
              </template>
              <v-card class="pa-3">
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">สถานะ</span>
                    <v-autocomplete
                      v-model="selectStatusRoleList"
                      :items="statusRoleList"
                      outlined
                      placeholder="ทั้งหมด"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      @click:clear="selectStatusRoleList='', searchFilterData(), page=1"
                    >
                    <template v-slot:[`item`]="{ item }">
                      <span style="color: rgba(0, 0, 0, 0.87);">{{ statusList.filter(e => e.status === item)[0].statusTH || '-' }}</span>
                    </template>
                    <template #selection="{ item }">
                      <span style="color: rgba(0, 0, 0, 0.87);">{{ statusList.filter(e => e.status === item)[0].statusTH || '-' }}</span>
                    </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="pt-3">
                  <v-col cols="12" class="pt-0 pb-0">
                    <span class="head-search-text">Tag</span>
                    <v-autocomplete
                      v-model="selectTagList"
                      :items="tagList"
                      outlined
                      placeholder="ทั้งหมด"
                      no-data-text="ไม่พบข้อมูล"
                      class="mt-2"
                      dense
                      clearable
                      @click:clear="selectTagList='', searchFilterData(), page=1"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row class="d-flex">
                  <v-spacer/>
                  <v-btn
                    class="head-search-button mr-2"
                    outlined
                    color="primary"
                    style="width: 60px;"
                    elevation="0"
                    @click="resetFilterData()"
                  >ล้าง</v-btn>
                  <v-btn
                    class="btn-search-dep ml-2 mr-3"
                    color="primary"
                    style="width: 94px;"
                    dark
                    @click="searchFilterData()"
                  >ค้นหา</v-btn>
                </v-row>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <span class="pl-12" style="font-weight: bold;">สิทธิ์หลัก</span>
        </v-row>
        <v-row>
          <v-col cols="12" class="px-12">
            <v-data-table
              :headers="headersPrimaryRole"
              :items="primaryRoleData"
              :items-per-page="5"
              class="border-table-employee text-no-wrap mt-0 elevation-0"
              item-key="no"
              disable-sort
            >
            <template v-slot:[`item.no`]="{ item }">
              <span>{{ primaryRoleData.indexOf(item) + 1}}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="['approve','acknowledge'].includes(item.status)? '#ECF8EA': ['reject'].includes(item.status)? '#FBE5E4': ['pending'].includes(item.status)? '#FEF5E9': ['cancel'].includes(item.status)? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === item.status)[0].color"
              >
                <span>{{ statusList.filter(e => e.status === item.status)[0].statusTH || '' }}</span>
              </v-chip>
            </template>
            <template v-slot:[`item.tag`]="{ item }">
              <span v-if="item.tag.length === 0"></span>
              <v-chip
                v-else
                v-for="(items, i) in item.tag" :key="i"
                :color="['approve','acknowledge'].includes('cancel')? '#ECF8EA': ['reject'].includes('cancel')? '#FBE5E4': ['pending'].includes('cancel')? '#FEF5E9': ['cancel'].includes('cancel')? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === 'cancel')[0].color"
              >
                <span>{{items}}</span>
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-row class="d-flex">
                <span v-if="item.status !== 'approve'"></span>
                <span v-else class="label-table-action" style="cursor: pointer; text-decoration: underline; color: #3776E9;" @click="$router.push('/managetransferrole/updateSubrole/' + item._id + '/' + propsitemsOrgchart)">ดูรายละเอียด</span>
              </v-row>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row>
          <span class="pl-12 mt-6" style="font-weight: bold;">สิทธิ์ย่อย</span>
        </v-row>
        <v-row>
          <v-col cols="12" sm="8" md="8" lg="8" class="pt-0 d-flex align-end pl-12" style="padding-bottom: 0px;">
            <!-- <v-row class="px-4">
              <span>รายการสิทธิ์ย่อยทั้งหมด {{subRoleSum.count}} รายการ</span>
            </v-row> -->
            <v-row class="px-1">
              <v-col cols="4">รายการสิทธิ์ย่อยทั้งหมด {{subRoleSum.count}} รายการ</v-col>
              <v-col :cols="$vuetify.breakpoint.name === 'xl' ? 2 : 6">
                <v-chip
                  :color="['approve','acknowledge'].includes(statusApproveRole)? '#ECF8EA': ['reject'].includes(statusApproveRole)? '#FBE5E4': ['pending'].includes(statusApproveRole)? '#FEF5E9': ['cancel'].includes(statusApproveRole)? '#F5F5F5':'#ECF9FF'"
                  :text-color="statusList.filter(e => e.status === statusApproveRole)[0].color"
                >
                  <span>{{ statusList.filter(e => e.status === statusApproveRole)[0].statusTH || '-' }}</span>
                </v-chip>
                <span class="mt-1 ml-1 mr-4">({{subRoleSum.approveSum}})</span>
                <v-chip
                  :color="['approve','acknowledge'].includes('pending')? '#ECF8EA': ['reject'].includes('pending')? '#FBE5E4': ['pending'].includes('pending')? '#FEF5E9': ['cancel'].includes('pending')? '#F5F5F5':'#ECF9FF'"
                  :text-color="statusList.filter(e => e.status === 'pending')[0].color"
                >
                  <span>{{ statusList.filter(e => e.status === 'pending')[0].statusTH || '-' }}</span>
                </v-chip>
                <span class="mt-1 ml-1 mr-4">({{subRoleSum.pendingSum}})</span>
              </v-col>
            </v-row>

          </v-col>
          <v-col cols="12" class="px-12">
            <v-data-table
              :headers="headersSecondRole"
              :items="secRoleData"
              :items-per-page="5"
              class="border-table-employee text-no-wrap mt-0 elevation-0"
              item-key="no"
              disable-sort
            >
            <template v-slot:[`item.no`]="{ item }">
              <span>{{ secRoleData.indexOf(item) + 1}}</span>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="['approve','acknowledge'].includes(item.status)? '#ECF8EA': ['reject'].includes(item.status)? '#FBE5E4': ['pending'].includes(item.status)? '#FEF5E9': ['cancel'].includes(item.status)? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === item.status)[0].color"
              >
                <span>{{ statusList.filter(e => e.status === item.status)[0].statusTH || '' }}</span>
              </v-chip>
            </template>
            <template v-slot:[`item.tag`]="{ item }">
              <span v-if="item.tag.length === 0"></span>
              <v-chip
                v-else
                v-for="(items, i) in item.tag" :key="i"
                :color="['approve','acknowledge'].includes('cancel')? '#ECF8EA': ['reject'].includes('cancel')? '#FBE5E4': ['pending'].includes('cancel')? '#FEF5E9': ['cancel'].includes('cancel')? '#F5F5F5':'#ECF9FF'"
                :text-color="statusList.filter(e => e.status === 'cancel')[0].color"
              >
                <span>{{items}}</span>
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-row class="d-flex">
                <span v-if="item.status !== 'approve'"></span>
                <span v-else class="label-table-action" style="cursor: pointer; text-decoration: underline; color: #3776E9;" @click="$router.push('/managetransferrole/updateSubrole/' + item._id + '/' + propsitemsOrgchart)">ดูรายละเอียด</span>
              </v-row>
            </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card>
      <!-- <v-row class="justify-space-between">
        <v-col cols="9" class="">
          <div class="elevation-0 dashboard-box-showdata pa-0 justify-space-around">
            test
          </div>
        </v-col>
      </v-row> -->
    </div>
    <div class="text-center">
      <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="snackbarColor"
        absolute
        text
        top
      >
      <v-icon left dark small :color="snackbarColor">fa-check-circle</v-icon>
      <span :style="{ 'color': `${snackbarColor}` }">{{ text }}</span>
      </v-snackbar>
    </div>
  </div>
</template>

<script>
import swal from 'sweetalert'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
// import DialogAddAprover from '../../manageCompany/_dialog/dialogAddApprover'
import {
// getUserByKeyword,
// insertApproveCompany
// hostImageUrlv3
} from '@/API/API'
const axios = require('axios')

export default {
  components: {
    // DialogAddAprover
    OverlayLoading
  },
  name: 'overview',
  data () {
    return {
      loading: false,
      snackbar: false,
      menu: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDeleteApprover: false,
      dialogApproverCompany: false,
      reqBusinessId: '',
      comment: '',
      titleDialog: '',
      itemConfirmDelete: [],
      panel: [0, 1],
      chkDataEmp: 0,
      userDataStore: '',
      tokenUser: '',
      subRoleSum: '',
      userIdList: [],
      userIdListTemporary: [],
      approver: [],
      statusApproveRole: 'approve',
      temporaryer: [],
      primaryRoleData: [],
      secRoleData: [],
      roleList: [],
      statusRoleList: [],
      tagList: [],
      selectRoleList: '',
      selectStatusRoleList: '',
      selectTagList: '',
      companyName: '',
      isSelecting: false,
      valid: true,
      orgChartDetail: '',
      inputRules: [
        v => !!v || 'กรุณากรอกข้อมูล'
      ],
      headersTemporary: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'วันที่รักษาการ', value: '' },
        { text: 'เอกสาร', value: '' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersPrimaryRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'สิทธิ์หลัก', value: 'name' },
        { text: 'สถานะการโอน', value: 'status' },
        { text: 'Tag', value: 'tag' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      headersSecondRole: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'สิทธิ์ย่อย', value: 'name' },
        { text: 'สถานะการโอน', value: 'status' },
        { text: 'Tag', value: 'tag' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ],
      statusList: [
        { status: 'pending', statusTH: 'ยังไม่โอน', color: '#E9A016' },
        { status: 'approve', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'reject', statusTH: 'ไม่อนุมัติ', color: '#D1392B' },
        { status: 'cancel', statusTH: 'ยกเลิก', color: '#757575' },
        { status: 'acknowledge', statusTH: 'รับทราบแล้ว', color: '#58A144' },
        { status: 'active', statusTH: 'โอนสิทธิ์แล้ว', color: '#58A144' },
        { status: 'expire', statusTH: 'หมดอายุ', color: '#D1392B' },
        { status: 'inActive', statusTH: 'ยกเลิก', color: '#757575' }
      ]
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
  },
  async created () {
    this.loading = true
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.propsitemsOrgchart = this.$route.params.orgchartId
    this.reqBusinessId = this.$route.params.id
    if (!this.$store.state.token) {
      this.goBack()
    } else {
      this.getSelectCompany()
      await this.getSelect(this.propsitems, this.propsitemsOrgchart)
      await this.getCompanyDetail(this.propsitems, this.propsitemsOrgchart)
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
    goBack () {
      this.$router.push('/managetransferrole')
      // this.$router.go(-1)
    },
    cancel () {
      this.$router.go(-1)
    },

    async resetFilterData () {
      this.selectRoleList = ''
      this.selectStatusRoleList = ''
      this.selectTagList = ''
      await this.searchFilterData()
    },
    async searchFilterData () {
      await this.getCompanyDetail(this.propsitems, this.propsitemsOrgchart)
    },
    onImgError (i) {
      // console.log('method: ', i)
      this.approver[i].failed_image = true
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/companys/selectGroupCompany`
      }).then((response) => {
        var dataReverse = response.data.result
        this.itemCompany = dataReverse
        // console.log('revers/e', this.itemCompany)
        this.itemCompany.push({
          _id: '',
          groupCompanyNameEng: 'ไม่มี'
        })
        this.itemCompany = this.itemCompany.reverse()
      }).catch(e => {
        console.log(e)
      })
    },
    async getSelect (id, orgchartId) {
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenListByIdSelect`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          orgchart: orgchartId,
          authenId: id
        }
      }).then((response) => {
        this.roleList = response.data.result[0].authen
        this.statusRoleList = response.data.result[0].status
        this.tagList = response.data.result[0].tag
      }).catch(e => {
        console.log(e)
      })
    },
    async getCompanyDetail (id, orgchartId) {
      this.loading = true
      const tempSecondRole = []
      const tempPrimaryRole = []
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/authenTransfer/authenListById`,
        headers: {
          authorization: this.$store.state.token
        },
        data: {
          orgchart: orgchartId,
          authenId: id,
          // orgchart: '6188ca4583cee44edcc2640c',
          // authenId: '617a6743b5d9de1b604e8cf1',
          authen: [this.selectRoleList],
          tag: [this.selectTagList],
          status: [this.selectStatusRoleList]
        }
      }).then((response) => {
        this.companyName = response.data.company.companyName
        this.orgChartDetail = response.data.orgchart.orgChartName
        response.data.result.mainAuthen.map((el, index) => {
          tempPrimaryRole.push({
            statusActive: el.status === 'inActive' ? false : el.status !== 'inActive' ? true : 'false',
            ...el
          })
        })
        response.data.result.subAuthen.subAuthen.map((el, index) => {
          tempSecondRole.push({
            statusActive: el.status === 'inActive' ? false : el.status !== 'inActive' ? true : 'false',
            ...el
          })
        })
        this.primaryRoleData = tempPrimaryRole
        this.secRoleData = tempSecondRole
        this.subRoleSum = response.data.result.subAuthen
        this.loading = false
        // this.dialogEdit = value
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    async toggleStatus (item) {
      this.loading = true
      try {
        await axios({
          url: `${process.env.VUE_APP_API_URL}:${process.env.VUE_APP_API_PORT}/api/vMonk/externalApi/changStatusActiveTokenByRole`,
          method: 'POST',
          data: {
            // serviceStatus: item.serviceStatus === 'on' ? 'off' : 'on',
            statusActive: item.statusActive,
            tokenId: item._id,
            role: this.approveRole
          },
          headers: {
            authorization: this.$store.state.token
          }
        })
          .then((response) => {
            if (response.data.success) {
              swal('สำเร็จ', 'เปลี่ยนสถานะสำเร็จ', 'success', {
                button: false,
                timer: 1000
              })
              this.searchFilterData(this.filterData)
            }
          })
      } catch (error) {
        swal('ผิดพลาด', 'เปลี่ยนสถานะไม่สำเร็จ กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.searchFilterData(this.filterData)
      } finally {
        // await this.searchFilterData()
        this.loading = false
      }
    },
    copyData () {
      this.$router.push({
        name: 'manageBusinescreate',
        params: {
          type: 'copy',
          id: this.reqBusinessId
        }
      })
    },
    goHistory (id) {
      this.$router.push('/managetransferrole/updateHistory/' + this.propsitems + '/' + this.propsitemsOrgchart)
      // this.$router.push({
      //   name: 'manageTransferroleupdateHistory',
      //   params: {
      //     type: 'new',
      //     id: ''
      //   }
      // })
    },
    goCreateTransfer () {
      this.$router.push('/managetransferrole/createTransferrole/' + this.propsitems + '/' + this.propsitemsOrgchart)
      // this.$router.push({
      //   name: 'manageTransferrolecreateTransferrole',
      //   params: {
      //     type: 'new',
      //     id: this.propsitemsOrgchart
      //   }
      // })
    }
  }
}
</script>
<style scoped>
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0 !important;
}
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 5px;
  color: #757575;
}
.txt-font-value {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
/* src\assets\logo.png */
/* '@/assets/icons/no_user.png' */
/* src\assets\icons\no_user.png */
.file-input {
  display: none;
}
.button {
  border: none;
  color: white;
  /* padding: 15px 32px; */
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
label {
  background-color: indigo;
  color: white;
  /* padding: 0.5rem; */
  padding: 0.7rem;
  font-family: sans-serif;
  border-radius: 0.3rem;
  cursor: pointer;
  margin-top: 1rem;
}
/* upfile pdf */
div.file-listing{
  width: 800px;
}
input[type="file"]{
  position: absolute;
  top: -500px;
  display:none;
}

  /* อัปโหลดไฟล์ */
  .upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.btn_click {
  border: 2px solid gray;
  /* color: gray; */
  background-color: white;
  padding: 8px 20px;
  border-radius: 8px;
  font-size: 15px;
  font-weight: bold;
}

.upload-btn-wrapper input[type=file] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.ra-head-text-bold {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #1654C6;
}
.ra-head-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
}
.ra-span-text {
  font-family: 'Sarabun', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  color: #757575;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
tr.v-data-table__selected {
    background: #7d92f5 !important;
  }
</style>
